import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { InformixTableDataset } from 'app/model/dataset/informix-table.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: adfModelTypeMap.informix.copySourceType,
    display: [],
    tags: {
        datasetModel: [
            Metamodel.modelFor(InformixTableDataset)
        ]
    }
})
export class InformixCopySource extends TabularCopySource {
}
